import { render, staticRenderFns } from "./LanguageSection.vue?vue&type=template&id=92685b76&scoped=true&"
import script from "./LanguageSection.vue?vue&type=script&lang=js&"
export * from "./LanguageSection.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSection.vue?vue&type=style&index=0&id=92685b76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92685b76",
  null
  
)

export default component.exports